import { useRoutes } from "react-router-dom";
import { useTypedSelector } from "@lib/redux";
import generateRoutes from "@lib/helpers/RouteGenerator";
import {
  anonymousStructure,
  authorizedStructure,
  authStructure,
} from "@app/.core/AppRoutes";

const App: React.FC = () => {
  const { user, isAuthenticated } = useTypedSelector((state) => state.auth);

  const generatedRoutes = generateRoutes({
    isAuthenticated: isAuthenticated,
    userRole: user?.role ? [user.role] : [],
    authStructure,
    authorizedStructure,
    anonymousStructure,
  });
  const routes = useRoutes(generatedRoutes);

  return routes;
};

export default App;
